import React from "react";

export default ({ headers }) => {
  return (
    <thead className="table-row">
      <tr>
        {headers.map((data) => (
          <th
            className="table-cell text-center"
            onClick={data.sortFunc}
            key={data.text}
          >
            <div className="headerDiv">{data.text}</div>
          </th>
        ))}
      </tr>
    </thead>
  );
};
